<div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value !== null" class="pt-2">
    <form [formGroup]="specBox3FormGroup">
        <div formGroupName="specificatieBox3">
            <div formGroupName="opbouw">
                <div class="row">
                    <div class="col-7">
                        Bankrekeningen Nederland
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="banktegoedenNederland"
                                id="banktegoedenNederland"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'banktegoedenBuitenland'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Bankrekeningen buitenland
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="banktegoedenBuitenland"
                                    id="banktegoedenBuitenland"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'beleggingen'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Beleggingen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="beleggingen"
                                    id="beleggingen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'groeneBeleggingenBanktegoeden'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Groene banktegoeden
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="groeneBeleggingenBanktegoeden"
                                    id="groeneBeleggingenBanktegoeden"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'groeneBeleggingenEffecten'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Groene beleggingen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="groeneBeleggingenEffecten"
                                    id="groeneBeleggingenEffecten"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'vrijstellingGroeneBeleggingen'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Af: Vrijstelling groene banktegoeden/beleggingen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="vrijstellingGroeneBeleggingen"
                                    id="vrijstellingGroeneBeleggingen"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <!--                <div-->
                <!--                        *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'saldoGroeneBeleggingen'])?.value > 0">-->
                <!--                    <div class="row">-->
                <!--                        <div class="col col-1">h</div>-->
                <!--                        <div class="col-2">-->
                <!--                            <snelstart-ui-number-form-control-->
                <!--                                    formControlName="saldoGroeneBeleggingen"-->
                <!--                                    id="saldoGroeneBeleggingen"-->
                <!--                                    class="custom-input-150"-->
                <!--                                    align="right"-->
                <!--                                    [decimals]="0"-->
                <!--                                    prefix="€"-->
                <!--                            ></snelstart-ui-number-form-control>-->
                <!--                        </div>-->
                <!--                        <div class="col-2"></div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'onroerendeZaken'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Onroerende zaken
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="onroerendeZaken"
                                    id="onroerendeZaken"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'crytoBezittingen'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Cryptobezittingen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="crytoBezittingen"
                                    id="vorderingen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'vorderingen'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Vorderingen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="vorderingen"
                                    id="vorderingen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'periodiekeUitkeringen'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Periodieke uitkeringen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="periodiekeUitkeringen"
                                    id="periodiekeUitkeringen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'kapitaalverzekeringen'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Kapitaalverzekeringen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="kapitaalverzekeringen"
                                    id="kapitaalverzekeringen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'premieDepots'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Premiedepots
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="premieDepots"
                                    id="premieDepots"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'bouwDepots'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Bouwdepots
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="bouwDepots"
                                    id="bouwDepots"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'contantGeld'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Contant geld
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="contantGeld"
                                    id="contantGeld"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'specBox3FormGroup'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Netto pensioen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="nettoPensioen"
                                    id="nettoPensioen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'overigeBezittingen'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Overige bezittingen
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="overigeBezittingen"
                                    id="overigeBezittingen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'schuldenNederlandsOG'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Af: Schulden Nederlandse onroerende zaken
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="schuldenNederlandsOG"
                                    id="schuldenNederlandsOG"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'schuldenBuitenlandsOG'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Af: Schulden buitenlandse onroerende zaken
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="schuldenBuitenlandsOG"
                                    id="schuldenBuitenlandsOG"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'overigeSchulden'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Af: Overige schulden
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="overigeSchulden"
                                    id="overigeSchulden"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'totaleSchulden'])?.value > 0 && specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'schuldenDrempel'])?.value > 0">
                    <div class="row">
                        <div class="col-7">
                            Bij: Drempel schuldenaftrek
                        </div>
                        <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'totaleSchulden'])?.value > specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'schuldenDrempel'])?.value"
                             class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="schuldenDrempel"
                                    id="schuldenDrempel"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'totaleSchulden'])?.value <= specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'schuldenDrempel'])?.value"
                             class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="overigeSchulden"
                                    id="overigeSchulden1"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <!--                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'schuldenNaDrempel'])?.value > 0">-->
                <!--                    <div class="row">-->
                <!--                        <div class="col col-1"></div>-->
                <!--                        <div class="col-2">-->
                <!--                            <snelstart-ui-number-form-control-->
                <!--                                    formControlName="schuldenNaDrempel"-->
                <!--                                    id="schuldenNaDrempel"-->
                <!--                                    class="custom-input-150"-->
                <!--                                    align="right"-->
                <!--                                    [decimals]="0"-->
                <!--                                    prefix="€ -"-->
                <!--                            ></snelstart-ui-number-form-control>-->
                <!--                        </div>-->
                <!--                        <div class="col-2"></div>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div class="row">
                    <div class="col-7">
                        <p>Rendementsgrondslag sparen en beleggen</p>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3">
                        <snelstart-ui-number-form-control
                                [decimals]="0"
                                align="right"
                                class="custom-input-150"
                                formControlName="rendementsGrondslag"
                                id="rendementsGrondslag"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value >=
                            (specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value +
                                (specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenPartner'])?.value || 0))"
                     class="left">
                    <div class="row">
                        <div class="col-7">
                            Af: Heffingsvrij vermogen
                        </div>
                        <div class="col-2"></div>
                        <div class="col-3">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="heffingsvrijVermogenAangever"
                                    id="heffingsvrijVermogenAangever"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                </div>
                <div *ngIf="this.specBox3.speciaficatiePartnerschap?.opbouw?.heeftFiscaalPartner === true &&
                            specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value >=
                            (specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value +
                                (specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenPartner'])?.value || 0))
                                ">
                    <div class="row">
                        <div class="col-7">
                            Af: Heffingsvrij vermogen partner
                        </div>
                        <div class="col-2"></div>
                        <div class="col-3">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="heffingsvrijVermogenPartner"
                                    id="heffingsvrijVermogenPartner"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                </div>
                <div *ngIf="!this.incomeTaxEntity.aangifte?.partnerAangifte && specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value >
                    (specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value + specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenPartner'])?.value)">
                    <div class="row">
                        <div class="col-7">
                            <p><b>Grondslag sparen en beleggen</b></p>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-3">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="grondslagSparenEnBeleggen"
                                    id="grondslagSparenEnBeleggen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                </div>
                <div *ngIf="this.incomeTaxEntity.aangifte?.partnerAangifte && specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value >
                    (specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value + specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenPartner'])?.value)">
                    <div class="row">
                        <div class="col-7">
                            <p><b>Grondslag sparen en beleggen</b></p>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-3">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="grondslagSparenEnBeleggen"
                                    id="grondslagSparenEnBeleggen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                </div>

                <div *ngIf="specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value > 0">
                    <div *ngIf="!this.incomeTaxEntity.aangifte?.partnerAangifte && specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value <
                                                    specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value">
                        <div style="width: 75%">
                            <snelstart-ui-alert type="info">
                                De rendementsgrondslag sparen en beleggen ad
                                € {{ specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value | number:'1.0-0' }}
                                is minder dan het vrijgestelde vermogen ad
                                € {{ specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value | number:'1.0-0' }}
                                .
                            </snelstart-ui-alert>
                        </div>
                    </div>
                    <div *ngIf="this.incomeTaxEntity.aangifte?.partnerAangifte && specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value ===
                                               specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value">
                        <div style="width: 75%">
                            <snelstart-ui-alert type="info">
                                De rendementsgrondslag sparen en beleggen ad
                                € {{ specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value | number:'1.0-0' }}
                                is gelijk aan het vrijgestelde vermogen ad
                                € {{ specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value | number:'1.0-0' }}
                                .
                            </snelstart-ui-alert>
                        </div>
                        <div *ngIf="this.incomeTaxEntity.aangifte?.partnerAangifte &&
                                    specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value
                                    <= (specBox3FormGroup.get(['specificatieBox3', 'opbouw',
                                    'heffingsvrijVermogenAangever'])?.value + specBox3FormGroup.get(['specificatieBox3',
                                    'opbouw', 'heffingsvrijVermogenPartner'])?.value)">
                            <div style="width: 75%">
                                <snelstart-ui-alert type="info">
                                    Het box 3-vermogen (de rendementsgrondslag sparen en beleggen) per 1
                                    januari {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} is
                                    € {{ specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value | number:'1.0-0' }}
                                    .
                                    De gezamenlijke vrijstelling box 3-vermogen {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} is
                                    € {{ (specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value + specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenPartner'])?.value) | number:'1.0-0' }}
                                    .
                                    <br/>Hierdoor is geen belasting over het vermogen verschuldigd.
                                </snelstart-ui-alert>
                            </div>
                        </div>
                    </div>
                </div>
                @if (incomeTaxEntity.aangifte?.partnerAangifte) {
                    <div *ngIf="this.incomeTaxEntity.aangifte?.partnerAangifte && specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value <=
                                (specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenAangever'])?.value + specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'heffingsvrijVermogenPartner'])?.value) &&
                                    this.incomeTaxEntity.aangifte?.partnerAangifte && specBox3FormGroup.get(['specificatieBox3', 'opbouw', 'rendementsGrondslag'])?.value > this.dataService.vermogensGrensVoorRegelingen">
                        <br/>
                        <div style="width: 75%">
                            <snelstart-ui-alert type="info">
                                De vermogensgrens per 1 januari {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} die bepalend is voor
                                inkomensafhankelijke regelingen (bijv. de toeslagen en rechtsbijstand) is
                                € {{ this.dataService.vermogensGrensVoorRegelingen | number: '1.0-0' }}. <br/>
                                Het vermogen per 1 januari {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} is meer. Verdeel daarom bij
                                het onderdeel 'Verdeling' de rendementsgrondslag tussen aangever en partner.
                            </snelstart-ui-alert>
                        </div>
                    </div>
                }
            </div>
        </div>
    </form>
</div>


<snelstart-venture-fiscaal-feature-box3-inkomen></snelstart-venture-fiscaal-feature-box3-inkomen>
